import { render, staticRenderFns } from "./ResumoReserva.vue?vue&type=template&id=17119538"
import script from "./ResumoReserva.vue?vue&type=script&lang=js"
export * from "./ResumoReserva.vue?vue&type=script&lang=js"
import style0 from "./ResumoReserva.vue?vue&type=style&index=0&id=17119538&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports